import React from 'react';
import { Tooltip as MuiTooltip } from '@material-ui/core';

import styles from './Tooltip.module.scss';

const Tooltip = ({ children, ...rest }) => (
  <MuiTooltip {...rest}>
    <div className={styles.tooltip}>{children}</div>
  </MuiTooltip>
);

export default Tooltip;
